module.exports = __webpack_public_path__ + "static/img4-dd5bc779264a481d499ec970f53def67.jpg";